import styled from 'styled-components';

import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { getCurrentLocale } from '@dreryk/react-common';

import { patientTranslationKeys } from '../../translations';
import { PatientUnconfirmedFormBean } from '../patientUnconfirmedUpdate.types';

import { ComparedPatientPreviewCard } from './ComparedPatientPreviewCard';
import { ComparedPatientPreviewInfoItem } from './ComparedPatientPreviewInfoItem';

type ComparedPatientPreviewContactDetailsSectionProps = {
   readonly patient: PatientUnconfirmedFormBean;
   readonly comparedPatient: Omit<PatientSimple, 'medicalDocumentationCreated'>;
   readonly onCopy: <VALUE>(name: string, value: VALUE) => void;
};

const StyledEmailInfoItem = styled.div`
   grid-column: 2 / span 2;
`;
StyledEmailInfoItem.displayName = 'StyledEmailInfoItem';

// eslint-disable-next-line max-lines-per-function
export const ComparedPatientPreviewContactDetailsSection = (
   props: ComparedPatientPreviewContactDetailsSectionProps
): JSX.Element => {
   const locale = getCurrentLocale();
   const { comparedPatient } = props;
   const comparedPatientCountry = comparedPatient.address?.getCountry().getName(locale);
   const comparedPatientTown = comparedPatient.address?.findTown()?.getName();
   const comparedPatientPostcode = comparedPatient.address?.findPostcode()?.asString();
   const comparedPatientStreet = comparedPatient.address?.findStreet()?.asString();
   const comparedPatientBuilding = comparedPatient.address?.findBuilding()?.asString();
   const comparedPatientFlat = comparedPatient.address?.findFlat()?.asString();
   const comparedPatientPhoneNumber = comparedPatient.phoneNumber?.asString();
   const comparedPatientEmail = comparedPatient.emailAddress?.asString();
   return (
      <ComparedPatientPreviewCard appointmentSourceLabel={props.comparedPatient.sourceLabel}>
         <ComparedPatientPreviewInfoItem
            label={patientTranslationKeys.unconfirmed.country}
            name={'country'}
            testId={'comparedPatientCountry'}
            value={comparedPatient.address?.getCountry()}
            displayValue={comparedPatientCountry}
            onCopy={props.onCopy}
            consistent={props.patient.country.getName(locale) === comparedPatientCountry}
         />
         <ComparedPatientPreviewInfoItem
            label={patientTranslationKeys.unconfirmed.town}
            name={'town'}
            testId={'comparedPatientTown'}
            value={comparedPatientTown}
            displayValue={comparedPatientTown}
            onCopy={props.onCopy}
            consistent={props.patient.town === comparedPatientTown}
         />
         <ComparedPatientPreviewInfoItem
            label={patientTranslationKeys.unconfirmed.postcode}
            name={'postcode'}
            testId={'comparedPatientPostcode'}
            value={comparedPatient.address?.findPostcode()}
            displayValue={comparedPatientPostcode}
            onCopy={props.onCopy}
            consistent={props.patient.postcode?.asString() === comparedPatientPostcode}
         />
         <ComparedPatientPreviewInfoItem
            label={patientTranslationKeys.unconfirmed.street}
            name={'street'}
            testId={'comparedPatientStreet'}
            value={comparedPatientStreet}
            displayValue={comparedPatientStreet}
            onCopy={props.onCopy}
            consistent={props.patient.street === comparedPatientStreet}
         />
         <ComparedPatientPreviewInfoItem
            label={patientTranslationKeys.unconfirmed.house}
            name={'house'}
            testId={'comparedPatientHouse'}
            value={comparedPatientBuilding}
            displayValue={comparedPatientBuilding}
            onCopy={props.onCopy}
            consistent={props.patient.house === comparedPatientBuilding}
         />
         <ComparedPatientPreviewInfoItem
            label={patientTranslationKeys.unconfirmed.flat}
            name={'flat'}
            testId={'comparedPatientFlat'}
            value={comparedPatientFlat}
            displayValue={comparedPatientFlat}
            onCopy={props.onCopy}
            consistent={props.patient.flat === comparedPatientFlat}
         />
         <ComparedPatientPreviewInfoItem
            label={patientTranslationKeys.unconfirmed.phoneNumber}
            name={'phoneNumber'}
            testId={'comparedPatientPhoneNumber'}
            value={comparedPatient.phoneNumber}
            displayValue={comparedPatientPhoneNumber}
            onCopy={props.onCopy}
            consistent={props.patient.phoneNumber?.asString() === comparedPatientPhoneNumber}
         />
         <StyledEmailInfoItem>
            <ComparedPatientPreviewInfoItem
               label={patientTranslationKeys.unconfirmed.email}
               name={'emailAddress'}
               testId={'comparedPatientEmailAddress'}
               value={comparedPatient.emailAddress}
               displayValue={comparedPatientEmail}
               onCopy={props.onCopy}
               consistent={props.patient.emailAddress?.asString() === comparedPatientEmail}
            />
         </StyledEmailInfoItem>
      </ComparedPatientPreviewCard>
   );
};
